import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import facilityImages from '../../../../../data/facilityImages.json';

export default function FacilityImageCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000
  };

  return (
    <div style={{ width: "100%", maxWidth: "800px", margin: "auto" }}>
  <Slider {...settings}>
    {facilityImages.map((src, i) => (
      <div key={i}>
        <div
          style={{
            height: "600px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#fff"
          }}
        >
          <img
            src={src}
            alt={`facility-${i}`}
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              objectFit: "contain"
            }}
          />
        </div>
      </div>
    ))}
  </Slider>
</div>
  );
}